export default __webpack_public_path__ + "static/media/roller-leaderboard.a0f86d08.gif";